import { useState } from "react";
import Config from "../../../Config";
import MediaBrowser from "../../../helpers/MediaBrowser";



function Calendar(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    const [tab, setTab] = useState(null);



    const getData = () => {


        props.mainView.setProgress(-2);

        var req = {

        };


        fetch( Config.url + '/rest_v1_parents,calendar', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);                                                                                         
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
               



    }


    if(tab == null)
        {
            setTab([]);
            getData();      
            return (
                <div></div>
            );        
        }


    
    if(refreshView != props.userData.refreshView)
    {         
          setRefreshView( props.userData.refreshView);
    }    
    
    

    return (
        <div>

        <h3>Zaplanowane wydarzenia w najbliższym czasie ({tab.length})</h3>

                     <ul className="parents_eat">

                         {
                            tab.map( (item, ix) => {

                                    return <li>
                                               <div className="calColor" >{item.dzien}, {item.temat_dnia}</div>
                                               <div>
                                                     <p> {item.forma_aktywnosci} </p> 
                                                     <p><b>Cel dnia:</b> {item.cel_dnia} </p> 
                                                     <p><b>Uwagi:</b> {item.uwagi_dodatkowe} </p> 
                                                     <p><b>Wymagane rzeczy:</b> 
                                                         {
                                                            item.wymagane.length > 2 &&
                                                            <span>{item.wymagane} </span>
                                                         }
                                                         {
                                                            item.wymagane.length < 2 &&
                                                            <span> nie podano </span>
                                                         }
                                                      
                                                     </p> 
                                               </div>
                                    </li>

                            } )
                         }   

                     </ul>
        </div>
    )
}


export default Calendar;